var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import { useMedia } from 'react-media-match';
import styled from '../utils/styled-components';
import priceTheme from './theme';
import FormattedCurrency, { formatCurrency } from '../FormattedCurrency';
var PriceWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: ", ";\n  display: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  flex-flow: ", ";\n"], ["\n  text-align: ",
    ";\n  display: ", ";\n  align-items: ",
    ";\n  justify-content: ",
    ";\n  flex-flow: ", ";\n"])), function (_a) {
    var component = _a.theme.component, layout = _a.layout;
    return component.price[layout].priceWrapper.textAlign;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout;
    return component.price[layout].priceWrapper.display;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout;
    return component.price[layout].priceWrapper.alignItems;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout;
    return component.price[layout].priceWrapper.justifyContent;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout;
    return component.price[layout].priceWrapper.flexFlow;
});
var LineWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  ", ";\n  white-space: ", ";\n  margin-right: ", ";\n"], ["\n  color: ",
    ";\n  font-size: ",
    ";\n  ", ";\n  white-space: ",
    ";\n  margin-right: ",
    ";\n"])), function (_a) {
    var component = _a.theme.component, variant = _a.variant, layout = _a.layout;
    return component.price[layout][variant].color;
}, function (_a) {
    var component = _a.theme.component, variant = _a.variant, layout = _a.layout, isMobile = _a.isMobile;
    return isMobile ? component.price[layout][variant].sizeMobile : component.price[layout][variant].size;
}, function (_a) {
    var component = _a.theme.component, variant = _a.variant;
    return component.price.default[variant].font;
}, function (_a) {
    var variant = _a.variant, isDetailViewLayout = _a.isDetailViewLayout;
    return isDetailViewLayout && variant === 'old' ? 'normal;' : 'nowrap';
}, function (_a) {
    var isDetailViewLayout = _a.isDetailViewLayout, component = _a.theme.component, layout = _a.layout, variant = _a.variant;
    return isDetailViewLayout ? component.price[layout][variant].marginRight : null;
});
var RowBreak = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-basis: 100%;\n  height: 0;\n  line-height: 0;\n"], ["\n  flex-basis: 100%;\n  height: 0;\n  line-height: 0;\n"])));
var OldPrice = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-decoration: line-through;\n"], ["\n  text-decoration: line-through;\n"])));
var Saving = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 0 0.25em;\n  margin-left: 0.25rem;\n  font-size: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  color: ", ";\n"], ["\n  padding: 0 0.25em;\n  margin-left: 0.25rem;\n  font-size: ",
    ";\n  background-color: ",
    ";\n  border-radius: ",
    ";\n  color: ",
    ";\n"])), function (_a) {
    var component = _a.theme.component, variant = _a.variant, layout = _a.layout;
    return component.price[layout][variant].size;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout, variant = _a.variant;
    return component.price[layout][variant].background;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout, variant = _a.variant;
    return component.price[layout][variant].borderRadius;
}, function (_a) {
    var component = _a.theme.component, layout = _a.layout, variant = _a.variant;
    return component.price[layout][variant].color;
});
export var Price = function (_a) {
    var className = _a.className, currency = _a.currency, _b = _a.isSale, isSale = _b === void 0 ? false : _b, _c = _a.isStartPrice, isStartPrice = _c === void 0 ? false : _c, _d = _a.isMSRP, isMSRP = _d === void 0 ? false : _d, _e = _a.layout, layout = _e === void 0 ? 'default' : _e, oldPrice = _a.oldPrice, price = _a.price, saving = _a.saving, _f = _a.savingType, savingType = _f === void 0 ? 'CURRENCY' : _f, _g = _a.savingPrefix, savingPrefix = _g === void 0 ? false : _g, unit = _a.unit, unitPrice = _a.unitPrice, amount = _a.amount, showLegalHints = _a.showLegalHints;
    var intl = useIntl();
    var isMobile = useMedia({ mobile: true, tablet: false, desktop: false });
    var isDetailviewLayout = layout.indexOf('detailView') !== -1;
    var variant = oldPrice ? 'reduced' : 'base';
    return (React.createElement(ThemeProvider, { theme: priceTheme },
        React.createElement(PriceWrapper, { className: className, layout: layout, isDetailViewLayout: isDetailviewLayout, variant: "base" },
            oldPrice && (React.createElement(React.Fragment, null,
                React.createElement(LineWrapper, { layout: layout, variant: "old", isDetailViewLayout: isDetailviewLayout },
                    isMSRP && React.createElement(FormattedMessage, { defaultMessage: "MSRP ", id: "price.msrp" }),
                    !isMSRP && (React.createElement(FormattedMessage, { defaultMessage: "Previous sales price ", id: "price.old.label" })),
                    React.createElement(OldPrice, null,
                        React.createElement(FormattedCurrency, { currency: currency, value: oldPrice }))),
                !saving && React.createElement(RowBreak, null))),
            saving && (React.createElement(React.Fragment, null,
                React.createElement(LineWrapper, { variant: "saving", isDetailViewLayout: isDetailviewLayout, layout: layout },
                    React.createElement(Saving, { layout: layout, variant: "saving", isDetailViewLayout: isDetailviewLayout }, (isStartPrice || oldPrice) && savingPrefix ? (React.createElement("span", { "data-testid": "saving-with-prefix" },
                        React.createElement(FormattedMessage, { id: "price.savingPrefix", defaultMessage: "bis -<saving>33%</saving>", values: {
                                saving: function () {
                                    return savingType === 'CURRENCY'
                                        ? formatCurrency(currency, saving, intl)
                                        : intl.formatNumber(saving / 100, {
                                            style: 'percent',
                                        });
                                },
                            } }))) : (React.createElement("span", { "data-testid": "saving-without-prefix" },
                        React.createElement("span", null, "-"),
                        savingType === 'CURRENCY' && (React.createElement(FormattedCurrency, { currency: currency, value: saving })),
                        savingType !== 'CURRENCY' && (
                        // eslint-disable-next-line react/style-prop-object
                        React.createElement(FormattedNumber, { currency: currency, style: "percent", value: saving / 100 })))))),
                React.createElement(RowBreak, null))),
            React.createElement(LineWrapper, { layout: layout, variant: variant, isDetailViewLayout: isDetailviewLayout, isMobile: isMobile },
                isStartPrice && React.createElement(FormattedMessage, { defaultMessage: "from", id: "price.from" }),
                isSale && React.createElement(FormattedMessage, { defaultMessage: "only", id: "price.sale" }),
                React.createElement(FormattedCurrency, { currency: currency, value: price })),
            unit && unitPrice && React.createElement(RowBreak, null),
            unitPrice && (React.createElement(LineWrapper, { layout: layout, variant: "unit", isDetailViewLayout: isDetailviewLayout }, isDetailviewLayout ? (React.createElement(FormattedMessage, { defaultMessage: "{price} per {amount, number} {unit}{amount, plural, one {} other {s}}", id: "price.perUnitExtended", values: {
                    price: formatCurrency(currency, unitPrice, intl),
                    unit: unit,
                    amount: amount,
                } })) : (React.createElement(FormattedMessage, { defaultMessage: "<price>0,00 $</price> / <unit>Gallon</unit>", id: "price.perUnit", values: {
                    price: function () { return formatCurrency(currency, unitPrice, intl); },
                    unit: function () { return unit; },
                } })))),
            showLegalHints && React.createElement(RowBreak, null),
            showLegalHints && (React.createElement(LineWrapper, { layout: layout, variant: "unit", isDetailViewLayout: isDetailviewLayout },
                React.createElement(FormattedMessage, { defaultMessage: "inkl. MwSt. zzgl.  Versandkosten", id: "price.showLegals" }))))));
};
export default Price;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map